(function () {
  var T = function (k, fb) { return (window.lifeI18n && window.lifeI18n[k]) || fb; };
  var PRIVACY_URL = '/policies/privacy-policy';
  var consented = false;

  function mount(form) {
    if (!form || form.nodeType !== 1) return;
    if (form.querySelector('[data-life-review-consent]')) return;
    var actions = form.querySelector('.vtl-pr-review-form__actions, .vtl-pr-wf__actions');
    if (!actions || !actions.parentNode) return;

    var box = document.createElement('div');
    box.className = 'life-review-consent';
    box.setAttribute('data-life-review-consent', '1');
    box.innerHTML =
      '<label class="life-review-consent__label">' +
        '<input class="life-review-consent__input" type="checkbox"' + (consented ? ' checked' : '') + ' aria-required="true">' +
        '<span>' + T('review_consent_before', 'Acconsento alla pubblicazione della recensione e ho preso visione della') + ' <a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">' + T('review_consent_link', 'Privacy Policy') + '</a>.</span>' +
      '</label>' +
      '<p class="life-review-consent__error" hidden>' + T('review_consent_error', 'Per inviare la recensione è necessario acconsentire alla pubblicazione e prendere visione della Privacy Policy.') + '</p>';

    actions.parentNode.insertBefore(box, actions);

    var input = box.querySelector('input');
    input.addEventListener('change', function () {
      consented = input.checked;
      if (!consented) return;
      var error = box.querySelector('.life-review-consent__error');
      if (error) error.hidden = true;
    });
  }

  function mountAll() {
    var forms = document.querySelectorAll('.vtl-pr-review-form, .vtl-pr-wf');
    for (var i = 0; i < forms.length; i++) mount(forms[i]);
  }

  function guard(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.vtl-pr-review-form__button--add, .vtl-pr-wf__submit-btn');
    if (!button) return;
    var form = button.closest('.vtl-pr-review-form, .vtl-pr-wf');
    if (form) mount(form);
    var input = form && form.querySelector('.life-review-consent__input');
    if (input && input.checked) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var error = form && form.querySelector('.life-review-consent__error');
    if (error) error.hidden = false;
    if (input) input.focus();
  }

  document.addEventListener('pointerdown', guard, true);
  document.addEventListener('mousedown', guard, true);
  document.addEventListener('click', guard, true);

  mountAll();
  new MutationObserver(mountAll).observe(document.documentElement, { childList: true, subtree: true });
})();
